export const colors = {
    primary: '#003F87',
    secondary: '#F47C00',
    darkGray: '#67696a',
    lightGray: '#b7b8b8',
    white: '#C8C8C8',
    error: '#FF0000',
    shadow: 'rgba(0,0,0,0.1)',
    backTarjetasBloques: '#e9edf4',
    backTarjetasDescargos: '#ffebd9',
    blueTarget: '#002060'
};